<template>
  <layout titlePage="Configurando seu site" :route="getRouterBack()">
    <progress
      class="progress onboarding-progress"
      :value="`${currentStepNumber}0`"
      :max="`${onboardingRoutes.length}0`"
    >{{ currentStepNumber }}0%</progress>
    <div
      v-if="answerUser.wed_id"
      class="onboarding-create-site onboarding-create-site--steps"
    >

      <div v-for="step in onboardingRoutes.length" :key="step">
        <transition :appear="step == 1" name="slide-fade" mode="in-out">
          <component :is="`step${step}`" v-if="showByStep(step)" :nextStepNumber="step + 1" :content="answerUser ?? undefined" />
        </transition>
      </div>
      
    </div>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'

import onboardingRoutes from '@/lib/onboarding/routers'

const steps = Array.from({ length: onboardingRoutes.length }, (_, i) => i + 1).reduce((acc, num) => {
  acc[`step${num}`] = () => import(`@/components/OnboardingCreationSite/Step${num}.vue`)
  return acc
}, {})

export default {
  components: {
    layout,
    ...steps
  },

  computed: {
    wedId() {
      return this.$store.getters['app/getWedId']
    },

    answerUser: {
      get() {
        return this.$store.state.onboardingCreateSite.answersOfStep
      },
      set(payload) {
        this.$store.dispatch('setAnswer', payload)
      },
    },

    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },

    currentStepNumber() {
      const stepNumber = this.$route.params.id.split('-')
      return parseInt(stepNumber[1])
    },
  },

  data() {
    return {
      onboardingRoutes
    }
  },

  watch: {
    wedId(payload) {
      if (payload) {
        this.initOnboarding()
      }
    },

    wedSiteInfo(info) {
      if (info) {
        this.initOnboarding()
      }
    },
  },

  mounted() {
    if (this.wedId) {
      this.initOnboarding()
    }
  },

  metaInfo: {
    title: 'Configurando seu site',
  },

  methods: {
    getRouterBack() {
      const route = this.currentStepNumber

      if (route !== 1) {
        return {
          path: '/onboarding/passo-' + (route - 1),
        }
      }
      return { path: '/onboarding/passo-1' }
    },

    initOnboarding() {
      this.$set(this.answerUser, 'wed_id', parseInt(this.wedId))

      if (this.wedSiteInfo) {
        const result = this.wedSiteInfo.site_url.split('/')
        this.answerUser.step1 = result[3]

        if (!this.wedSiteInfo.onboarding_concluido) {
          let dataLocalStorage = JSON.parse(
            localStorage.getItem(`onboarding_wed${this.wedId}`)
          )

          if (!dataLocalStorage) {
            localStorage.setItem(
              `onboarding_wed${this.wedId}`,
              JSON.stringify({ onboarding_concluido: true })
            )
          }
        } else {
          this.$router.push({ path: '/onboarding/passo-6' })
        }
      }
    },

    showByStep(step) {
      return this.currentStepNumber == step
    },
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  margin-top: 0px;

  &--steps {
    margin-top: 0px;
  }

  &__img {
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    padding: 0;
    border-top-right-radius: 130px;
    border-bottom-right-radius: 130px;
    overflow: hidden;
    min-height: inherit;
    height: auto;
  }

  &__description {
    height: 100%;
    padding: 25px 15px 20px 23px;
    min-height: calc(100vh - 68px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 0px;

    @media (min-width: $tablet) {
      padding: 30px;
      height: auto;
    }

    &--width-80 {
      display: flex;
      flex-direction: column;
      justify-content: center;

      @media (min-width: $desktop) {
        max-width: 80%;
        margin: 0 auto;
      }
    }
  }

  &__emotion {
    font-size: 32px;
    margin-bottom: 30px;

    @media (min-width: $tablet) {
      font-size: 45px;
    }
  }

  &__title {
    color: $gray-7;
    font-size: 20px;
    margin-bottom: 20px;

    @media (min-width: $tablet) {
      margin-bottom: 8px;
    }
  }

  &__subtitle {
    color: $gray-7;
    font-size: 18px;
    max-width: 675px;
    margin: 0 auto;
    margin-bottom: 24px;
    line-height: 32px;

    @media (min-width: $tablet) {
      font-size: 24px;
    }
  }

  &__paragraph {
    margin-bottom: 20px;
    color: $gray-7;
  }
}

.onboarding-progress {
  height: 8px;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0;
  margin: 0 !important;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(2, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(20px);
  opacity: 0;
}
</style>
